import React from 'react';

const StocksInRequestPage = React.lazy(() => import('pages/StocksInRequest/StocksInRequestPage'));
const StocksInRequestAddPage = React.lazy(() => import('pages/StocksInRequest/StocksInRequestAddPage'));

const stocksInRequestRoute = [
  {
    path: '/stocks-in-request',
    exact: true,
    name: 'Danh sách nhận hàng và phiếu nhập',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: StocksInRequestPage,
  },
  {
    path: '/stocks-in-request/add',
    exact: true,
    name: 'Thêm mới nhận hàng và phiếu nhập',
    function: 'ST_STOCKSINREQUEST_ADD',
    component: StocksInRequestAddPage,
  },
  {
    path: '/stocks-in-request/detail/:stocks_in_request_id',
    exact: true,
    name: 'Chi tiết nhận hàng và phiếu nhập',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: StocksInRequestAddPage,
  },
  {
    path: '/stocks-in-request/edit/:stocks_in_request_id',
    exact: true,
    name: 'Chỉnh sửa nhận hàng và phiếu nhập',
    function: 'ST_STOCKSINREQUEST_EDIT',
    component: StocksInRequestAddPage,
  },
];

export default stocksInRequestRoute;
